import { memo, useMemo } from 'react';

import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';
import { VisitAndAppointmentView } from '@dreryk/egabinet-visit-frontend-api';

import { EmptyStatePlaceholder, Table, TableDataAccessor } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { VisitSettlementStatusResolver } from '~libs.shared.visit-settlement';

import { appointmentsTranslationKeys } from '../../translations';

import { useAppointmentsDataConfiguration, useAppointmentsTableColumns } from './AppointmentsTable.hooks';
import { PreInterviewResolver } from './PreInterviewResolver';

const AppointmentsTableDataAccessor: TableDataAccessor<VisitAndAppointmentView> = (props) => {
   const appointmentIds = useMemo<number[]>(() => {
      return props.currentPage.map((appointment) => appointment.appointmentId);
   }, [props.currentPage]);

   return (
      <>
         <VisitSettlementStatusResolver appointmentIds={appointmentIds} />
         {protectFeature('conductingPreInterview', <PreInterviewResolver appointmentIds={appointmentIds} />, null)}
      </>
   );
};

type AppointmentsTableProps = {
   readonly currentDoctor: DoctorSimple | null;
   readonly doctors: DoctorSimple[];
   readonly doctorsFilterAvailable: boolean;
};

const AppointmentsTable = (props: AppointmentsTableProps): JSX.Element => {
   const dataConfiguration = useAppointmentsDataConfiguration(props.currentDoctor, props.doctors);
   const columns = useAppointmentsTableColumns(dataConfiguration.refetch, props.doctorsFilterAvailable);

   return (
      <>
         <Table<VisitAndAppointmentView>
            testId={'appointments'}
            keyExtractor={'appointmentId'}
            columns={columns}
            dataConfiguration={dataConfiguration}
            dataAccessor={AppointmentsTableDataAccessor}
            pageSize={50}
            placeholder={
               <EmptyStatePlaceholder
                  heading={appointmentsTranslationKeys.noAppointments.noAppointments}
                  subheading={appointmentsTranslationKeys.noAppointments.noResults}
                  testId={'noAppointments'}
               />
            }
         />
      </>
   );
};

const MemoizedAppointmentsTable = memo(AppointmentsTable);

export { MemoizedAppointmentsTable as AppointmentsTable };
